import TreeNodeSet from "../tree/TreeNodeSet";

export default function TreeSelectionController(tree )
{
    this.tree = tree;
    this.nodeSet = new TreeNodeSet();
    this.initiallySelectedNodeSet = new TreeNodeSet();
}

TreeSelectionController.prototype.markSelected = function( treeNode )
{
    this.nodeSet.add( treeNode );
};

TreeSelectionController.prototype.markSelectedAndUpdate = function( treeNode )
{
    this.markSelected( treeNode );
    this.tree.updateUIForSingleTreeNode(treeNode);
};

TreeSelectionController.prototype.nodeSelected = function( treeNode )
{
    this.markSelectedAndUpdate( treeNode );
};

TreeSelectionController.prototype.initializeByNodeSet = function(nodeSet)
{
    this.initiallySelectedNodeSet = nodeSet;
};

TreeSelectionController.prototype.markDeselected = function( treeNode )
{
    this.nodeSet.remove( treeNode );
};

TreeSelectionController.prototype.markDeselectedAndUpdate = function( treeNode )
{
    this.markDeselected( treeNode );
    this.tree.updateUIForSingleTreeNode(treeNode);
};

TreeSelectionController.prototype.nodeDeselected = function( treeNode )
{
    this.markDeselectedAndUpdate( treeNode );
};

TreeSelectionController.prototype.toggle = function( treeNode )
{
    if( this.isSelected( treeNode ) )
        this.nodeDeselected( treeNode );
    else
        this.nodeSelected( treeNode );
};

TreeSelectionController.prototype.isSelected = function ( treeNode )
{
    return this.nodeSet.contains( treeNode );
};

TreeSelectionController.prototype.deselectAll = function ()
{
    var oldSelection = this.nodeSet;
    this.nodeSet = new TreeNodeSet();
    this.tree.updateUIForTreeNodeSet(oldSelection);
};

TreeSelectionController.prototype.getSelectedNodeSet = function ()
{
    return this.nodeSet;
};

TreeSelectionController.prototype.getInitiallySelectedNodeSet = function ()
{
    return this.initiallySelectedNodeSet;
};

TreeSelectionController.prototype.updateUI = function()
{
    this.tree.updateUIForTreeNodeSet(this.nodeSet);
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/selectionTree/TreeSelectionController.js